export default "__VITE_ASSET__CIgnrCvd__"